import type {
  CancelarContratoUseCase,
  GerarContratoUseCase,
  GetContratoUseCase,
  ListContratosByMatriculaUseCase,
  RenderizarContratoUseCase,
  RegistrarAssinaturaContratoUseCase,
} from '@/application/port/in/ContratoUseCase';
import type {
  GerarContratoCommand,
  RenderizarContratoCommand,
} from '@/application/port/in/dto/ContratoCommand';
import type { ContratoGateway } from '@/application/port/out/ContratoGateway';
import type { Contrato } from '@/domain/model/Contrato';

export class ListContratosByMatriculaUseCaseImpl
  implements ListContratosByMatriculaUseCase
{
  constructor(private readonly gateway: ContratoGateway) {}
  execute(matriculaId: string): Promise<Contrato[]> {
    if (!matriculaId)
      return Promise.reject(new Error('ID da matrícula é obrigatório'));
    return this.gateway.listByMatricula(matriculaId);
  }
}

export class GetContratoUseCaseImpl implements GetContratoUseCase {
  constructor(private readonly gateway: ContratoGateway) {}
  execute(id: string): Promise<Contrato> {
    if (!id) return Promise.reject(new Error('ID do contrato é obrigatório'));
    return this.gateway.getById(id);
  }
}

export class GerarContratoUseCaseImpl implements GerarContratoUseCase {
  constructor(private readonly gateway: ContratoGateway) {}
  execute(command: GerarContratoCommand): Promise<Contrato> {
    return this.gateway.gerar(command);
  }
}

export class RenderizarContratoUseCaseImpl
  implements RenderizarContratoUseCase
{
  constructor(private readonly gateway: ContratoGateway) {}
  execute(command: RenderizarContratoCommand): Promise<Contrato> {
    return this.gateway.renderizar(command);
  }
}

export class CancelarContratoUseCaseImpl implements CancelarContratoUseCase {
  constructor(private readonly gateway: ContratoGateway) {}
  execute(id: string): Promise<void> {
    if (!id) return Promise.reject(new Error('ID do contrato é obrigatório'));
    return this.gateway.cancelar(id);
  }
}

export class RegistrarAssinaturaContratoUseCaseImpl implements RegistrarAssinaturaContratoUseCase {
  constructor(private readonly gateway: ContratoGateway) {}
  execute(id: string, clicksignKey: string): Promise<Contrato> {
    return this.gateway.registrarAssinatura(id, clicksignKey);
  }
}
